import makeModal from '@/views/modal/make_modal';
import track from '@/helpers/track';

let contactsModal = null;
let localeSwitcherModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (contactsModal) {
    contactsModal.destroy();
    contactsModal = null;
  }

  if (localeSwitcherModal) {
    localeSwitcherModal.destroy();
    localeSwitcherModal = null;
  }
});

$(document).on('turbolinks:load', async () => {
  if (!document.body.className.includes('v4')) { return; }

  $('footer.b-footer.v4 button.lead').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    contactsModal ||= makeModal({
      trigger: currentTarget,
      silhouette: 'call_lead',
      importComponent: async () => await import('@/vue/modals/call_lead'),
      props: {
        submitUrl: $node.data('submit_url'),
        leadType: $node.data('lead-type'),
        trackEvent: $node.data('track-event'),
        trackEventLocation: $node.data('track-event-location'),
        privacyUrl: $node.data('privacy_url'),
        privacyConsentUrl: $node.data('privacy_consent_url'),
        faqUrl: $node.data('faq_url'),
        graphqlUrl: $node.data('graphql_url')
      },
      isCloseOnSubmit: true,
      onShow: () => {
        track({
          event: 'callback_form_opened',
          form_location: $node.data('track-event-location')
        });
      }
    })
      .show();
  });

  $('footer.b-footer.v4 .locale_switcher-modal-trigger').one('click', async ({ currentTarget }) => {
    localeSwitcherModal ||= makeModal({
      trigger: currentTarget,
      silhouette: 'locale_switcher',
      importComponent: async () => await import('@/vue/modals/locale_switcher')
    })
      .show();
  });
});
